/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-01 16:18:49
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 16:37:09
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/ProductCategory/EditModal/Root.tsx
 */
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import React from 'react';
import { Input } from 'src/components/Antd';
import Slug from 'src/constrains/SlugInput';
import { useI18n } from 'src/hooks/useRouterChange';
import { cancelRequest } from 'src/tools/server';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const GeneralModal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onCancel,

    name: _name,
    urlSlug: _urlSlug,
    salesChannelUuid,
    uuid: selfUuid,
    //isSlugRequired = false,
    slugCheckingUrl,
    requestId,
    onSubmit,
  } = props;

  const [name, setName] = React.useState(_name || '');
  const [nameErr, setNameErr] = React.useState('');
  const [slugValid, setSlugValid] = React.useState(true);
  const [urlSlug, setUrlSlug] = React.useState(_urlSlug || '');

  const [slugError, setSlugError] = React.useState(false);
  React.useEffect(() => {
    return () => {
      cancelRequest(requestId);
    };
  }, []);
  const handleOnSubmit = () => {
    if (!name) {
      setNameErr(getI18n('general.validNameError'));
      return;
    }

    if (!slugValid) {
      return;
    }
    if (!urlSlug) {
      setSlugError(true);
      return;
    }
    onSubmit({ urlSlug, name });
    // postCategoryProduct(
    //   {
    //     uuid: selfUuid,
    //     salesChannelUuid,
    //     urlSlug,
    //     name,
    //   },
    //   { requestSourceID: `postCategoryProduct${salesChannelUuid}` },
    // ).then((res) => {
    //   if (onOk) onOk(res);
    // });
  };
  return (
    <React.Fragment>
      <div className={css.container}>
        <ItemWrapper
          title={`${getI18n('general.categoryName')}*`}
          rightSubTitle={getI18n('general.categorynameasSEOtitle')}>
          <Input
            error={!!nameErr}
            help={nameErr}
            size='large'
            maxLength={100}
            value={name}
            onChange={(e) => {
              setName(e);
              setNameErr('');
            }}
          />
        </ItemWrapper>
        <Slug
          value={urlSlug}
          displayDangerousNotice
          url={slugCheckingUrl}
          slugValid={slugValid}
          fixedParams={{
            salesChannelUuid: salesChannelUuid,
            uuid: selfUuid,
          }}
          onChange={({ slug, valid }) => {
            setSlugValid(valid);
            setUrlSlug(slug);
            if (slugError) setSlugError(false);
          }}
          customError={slugError}
          customHelper={getI18n('general.slugCannotbeEmpty')}
        />
      </div>
      <ModalFooter
        okText={getI18n('general.confirm')}
        onCancel={onCancel}
        onOk={handleOnSubmit}
      />
    </React.Fragment>
  );
};
export default GeneralModal;
